import {parse} from 'qs'

import {isBrowser} from '../environment'
import {warnServerEnvironment} from '../logging/server-warning'

/**
 *
 * Parses URL into a detailed object
 * @returns An object with parsed details about the URL
 * @param url the url to be parsed
 */
export const parseUrl = (url: string) => {
  const urlObj = new URL(url)
  const sanitizedSearchString = urlObj.search.replace(/^\?/g, '')

  const searchObject = parse(sanitizedSearchString, {ignoreQueryPrefix: true})

  return {
    protocol: urlObj.protocol,
    host: urlObj.host,
    hostname: urlObj.hostname,
    port: urlObj.port,
    pathname: urlObj.pathname,
    hash: urlObj.hash,
    search: sanitizedSearchString,
    searchObject
  }
}

/**
 * Converts an url into base 64 and removes unsafe characters
 * @param url URL you want to convert.
 * @returns a base64 string
 */
export const safeBase64Url = (url: string) => {
  if (typeof window === 'undefined') {
    return Buffer.from(url)
      .toString('base64')
      .replace('+', '-')
      .replace('/', '_')
      .replace(/=+$/, '')
  }
  return window.btoa(url).replace('+', '-').replace('/', '_').replace(/=+$/, '')
}

/**
 * Returns the URL parameters as an object.
 * @deprecated Use getQueryStringObject instead.
 */
export const getUrlParams = () => {
  if (!isBrowser) {
    warnServerEnvironment(`getQueryStringObject`)
    return {}
  }

  return parse(location?.search, {
    ignoreQueryPrefix: true
  })
}

export const getQueryStringObject = getUrlParams
